export interface TestFileDto {
    Id: number;
    FileType: string;
    ContentTypeId: number | null;
    EncodingId: number | null;
    Filename: string | null;
    UploadFileGuid: string | null;
    Note: string | null;
    CreatedDate: Date;
    CreatedBy: number;
    UpdatedDate: Date | null;
    UpdatedBy: number | null;
}

export class TestFileType {
    static TypeUnknown = 'Unknown';
    static TypeOriginalInterchangeIn = 'OriginalInterchangeIn';
    static TypeOriginalInitConfiguration = 'OriginalInitConfiguration';
    static TypeOriginalInterchangeInContextProperties = 'OriginalInterchangeInContextProperties';
    static TypeExpectedInterchangeOut = 'ExpectedInterchangeOut';
}